import { Box, makeStyles, useTheme } from '@material-ui/core'
import React from 'react'
import { CardAction, CardActionProps } from '../cardActions/cardActions'
import { styles } from './cardBottom.styles'

export interface CardBottomProps {
  actions?: CardActionProps[]
}

export const CardBottom: React.FC<CardBottomProps> = ({ actions }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()
  return (
    <Box className={classes.cardActionsRight}>
      {actions &&
        actions.length > 0 &&
        actions.map((action, index) => {
          const showAction = action.visibleIf === undefined || action.visibleIf // visibleIf is optional parameter
          const { label, hasPermission, handleActionClick, size, color, ...otherActionsProps } =
            action
          return (
            showAction && (
              <CardAction
                className={classes.cardActionButton}
                key={index}
                label={label}
                hasPermission={hasPermission}
                handleActionClick={handleActionClick}
                size={size}
                color={color}
                {...otherActionsProps}
              />
            )
          )
        })}
    </Box>
  )
}
